// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import axios from "axios"

Vue.use(ElementUI);
Vue.config.productionTip = false;

let IS_PROD = process.env.NODE_ENV === "production";
let service_host;
let sso_login_url;

if (IS_PROD) {
  service_host = "";
  sso_login_url = "http://cloud.jj-robot.com/accounts/login/?next=https://idface.jj-robot.com";
} else {
  service_host = "http://idface.jj-robot.com:9111";
  sso_login_url = "http://cloud.jj-robot.com:8000/accounts/login/?next=http://localhost:8080"
}

axios.defaults.baseURL = `${service_host}/api/v1`; // if dev mode check config.dev.env.js
axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      window.location.href = sso_login_url;
      return
    }
    return Promise.reject(error)
  }
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js